/** Sign-in card. The button kicks off the full-page redirect to Guardius's
 *  hosted /auth/authorize page where SIWE actually happens; on return the
 *  AuthProvider exchanges the code. Any callback error (e.g. state mismatch) is
 *  surfaced here via the provider.
 *
 *  When `config.tenantId` is empty the console can't mint a management-tenant
 *  token, so we also show a developer hint to create `dashboard/config.local.json`
 *  (an empty tenantId only ever happens in local dev — a real deploy always
 *  ships config.json with a concrete tenant). */

import { useState } from 'react';
import { useAuth } from '../lib/auth';

export default function Login() {
  const { config, signIn, error } = useAuth();
  const [localError, setLocalError] = useState<string | null>(null);

  const handleSignIn = async () => {
    setLocalError(null);
    try {
      await signIn();
    } catch (e) {
      setLocalError(e instanceof Error ? e.message : 'Sign-in failed.');
    }
  };

  const message = localError ?? error;

  return (
    <div className="login">
      <div className="card">
        <h1>Penseur Watchtower</h1>
        <button type="button" className="btn btn-signin" onClick={handleSignIn}>
          Sign in with Guardius
        </button>
        {message && (
          <p className="error" role="alert">
            {message}
          </p>
        )}
        {config.tenantId === '' && (
          <p className="note">
            No management tenant configured. Create{' '}
            <code>dashboard/config.local.json</code> with a concrete{' '}
            <code>tenantId</code> to sign in locally.
          </p>
        )}
      </div>
    </div>
  );
}
